import React, { Component } from "react"
import TextBlock from "./FeaturedBlocks/TextBlock"
import VideoBlock from "./FeaturedBlocks/VideoBlock"
import ImageBlock from "./FeaturedBlocks/ImageBlock"
import FaqBlock from "./FeaturedBlocks/FaqBlock"
import ContactForm from "./FeaturedBlocks/ContactForm"
import GeneralTable from "./FeaturedBlocks/GeneralTable"
import ImageGrid from "./FeaturedBlocks/ImageGrid"
import ColumnedImageText from "./Blocks/ColumnedImageText"
import HorizontalImageText from "./Blocks/HorizontalImageText"
import GalleryCarousel from "./FeaturedBlocks/GalleryCarousel"

class FlexibleContentFeatured extends Component  {

    render() {
        let blocks = ""

        if (this.props.blocks) {
            blocks = this.props.blocks.map((block, i) => {
                // console.log(block.__typename)
                // Double cases as this is used on pages and posts
                switch (block.__typename) {
                    case 'WpTemplate_FeatureArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_TextBlock':
                    case 'WpPost_Acftwocolumnflexiblecontent_TwoColumnBlocks_TextBlock':
                        return <TextBlock data={block} key={i} />

                    case 'WpTemplate_FeatureArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_VideoBlock':
                    case 'WpPost_Acftwocolumnflexiblecontent_TwoColumnBlocks_VideoBlock':
                        return <VideoBlock data={block} key={i} />

                    case 'WpTemplate_FeatureArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_ImageBlock':
                    case 'WpPost_Acftwocolumnflexiblecontent_TwoColumnBlocks_ImageBlock':
                        return <ImageBlock data={block} key={i} />

                    case 'WpTemplate_FeatureArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_FaqBlock':
                    case 'WpPost_Acftwocolumnflexiblecontent_TwoColumnBlocks_FaqBlock':
                        return <FaqBlock data={block} key={i} />

                    case 'WpTemplate_FeatureArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_ContactForm':
                    case 'WpPost_Acftwocolumnflexiblecontent_TwoColumnBlocks_ContactForm':
                        return <ContactForm data={block} key={i} />

                    case 'WpTemplate_FeatureArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_GeneralTable':
                    case 'WpPost_Acftwocolumnflexiblecontent_TwoColumnBlocks_GeneralTable':
                        return <GeneralTable data={block} key={i} />

                    case 'WpTemplate_FeatureArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_ImageGrid':
                    case 'WpPost_Acftwocolumnflexiblecontent_TwoColumnBlocks_ImageGrid':
                        return <ImageGrid data={block} key={i} />

                    case 'WpTemplate_FeatureArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_ColumnedImageWithText':
                    case 'WpPost_Acftwocolumnflexiblecontent_TwoColumnBlocks_ColumnedImageWithText':
                        return <ColumnedImageText block={block} key={i} padding={false} />

                    case 'WpTemplate_FeatureArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_HorizontalImageWithText':
                    case 'WpPost_Acftwocolumnflexiblecontent_TwoColumnBlocks_HorizontalImageWithText':
                        return <HorizontalImageText block={block} key={i} />
                        
                    case 'WpTemplate_FeatureArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_GalleryCarousel':
                    case 'WpPost_Acftwocolumnflexiblecontent_TwoColumnBlocks_GalleryCarousel':
                        return <GalleryCarousel block={block} key={i} />
                        
                    default:
                        return "";
                }
            })

        }

        return blocks
    }
} 

export default FlexibleContentFeatured